import * as React from 'react';

type UseFilenameEditModeParams = {
    filename: string;
};

export function useFilenameEditMode({ filename }: UseFilenameEditModeParams) {
    let [isEditing, setIsEditing] = React.useState(false);

    React.useEffect(
        function resetOnNavigateToDifferentImage() {
            setIsEditing(false);
        },
        [filename]
    );

    function enterEditMode() {
        setIsEditing(true);
    }

    function exitEditMode() {
        setIsEditing(false);
    }

    return {
        isEditing,
        enterEditMode,
        exitEditMode
    };
}
